import React from "react";

function loader(props) {
  return (
    <div
      className={
        "mirror_loader flex_center" + (props.main ? " main_page_loader" : "")
      }
    >
      <img
        alt=""
        src={process.env.REACT_APP_STATIC_URL + "/images/mirror_loader.gif"}
      />
    </div>
  );
}

export default loader;
